import EfCardsAppA from '@elem/ui/ef-cards-app-a';
import EfTitle from '@elem/ui/ef-title';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.ListC');
    const itemsA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725589828752/service_01.png',
            title: t('a_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725589828883/service_02.png',
            title: t('b_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725589829190/service_03.png',
            title: t('c_title'),
        },
    ];
    return (
        <div className={styles.TheComp}>
            <EfTitle>{t('title')}</EfTitle>
            <EfCardsAppA list={itemsA} />
        </div>
    );
}
